<template>
  <div class="d-flex justify-content-center align-items-center">
    <div class="mt-2 d-flex align-content-center">
      <div v-if="imageUrl" class="device-preview">
        <img :src="imageUrl" alt="device" />
      </div>
      <div class="">
        <p>{{ deviceName }}</p>
        <div v-if="price">
          {{ t("COUNTED_PRICE") }}
          <p>{{ formatCurrency(price, locale, currency.code) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "@/apps/merchant3/composables/useI18n";
const { t } = useI18n();
import { ICurrencyType } from "@/apps/merchant3/shared-hooks/useCurrency";
import { PropType } from "vue";
import { formatCurrency } from "@/apps/merchant3/shared-helpers/currency-helper";
defineProps({
  imageUrl: {
    type: String || null,
    default: null,
    required: false,
  },
  deviceName: String,
  price: {
    type: Number || String,
    default: 0,
    required: false,
  },
  currency: {
    type: Object as PropType<ICurrencyType>,
    default: () => ({ name: "US Dollar", code: "USD", sign: "$" }),
  },
  locale: {
    type: String,
    default: "en-US",
  },
});
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";
</style>
